

import { z } from 'zod';
import { AddressSchema } from '../common/AddressSchema';
import { OrderInfoSchema } from '../order/OrderSchema';
export type  CustomerInfoSchema = {
  customerId:  string,
  name: string,
  address: string,
  phone: string,
  email: string,
  logo: string,
  isDeleted: boolean,
  aspectRatios:string[],
  orders:OrderInfoSchema[],
  isActive:boolean,
  error :string
}

export  const PictureSchema = z.object({
  pictureId: z.string().uuid().optional().nullable(),
  data: z.string().optional().nullable(),
 
})

export const ContactSchema = z.object({
  contactId: z.string().uuid().optional().nullable(),
  last: z.string().optional().nullable(),
  first: z.string().optional().nullable(),
  mobile: z.string().optional().nullable(),
  phone: z.string().optional().nullable(),
  fax: z.string().optional().nullable(),
  email: z.string().optional().nullable(),
  website: z.string().optional().nullable(),
  addressId: z.string().uuid().optional().nullable(),
  address: AddressSchema.default({}),
  pictureId: z.string().uuid().optional().nullable(),
  picture: PictureSchema.default({}).optional().nullable(),
})

export  const CustomerSchema = z.object({
  customerId: z.string().uuid().optional().nullable(),
  contactId: z.string().uuid().optional().nullable(),
  isActive: z.boolean().default(true),
  fileDirectory: z.string(),
  contact:ContactSchema,
  contacts: z.array(ContactSchema)
})

